import {
    Box,
    Card,
    CardContent,
    Divider,
    Skeleton,
    Stack,
    Typography,
} from '@mui/material';
import { FormValues as Experience } from '../../../../types/experience';
import React from 'react';
import { useNavigate } from 'react-router';
import { NavigateNext } from '@mui/icons-material';
import UserRole from '../../../../../shared/AuthRoles';

interface ExperiencePreviewProps {
    experience: Experience;
}

const ExperiencePreview = ({ experience }: ExperiencePreviewProps) => {
    const navigate = useNavigate();
    const loggedInUser = UserRole();

    const days = [
        { key: 'monday', label: 'Monday' },
        { key: 'tuesday', label: 'Tuesday' },
        { key: 'wednesday', label: 'Wednesday' },
        { key: 'thursday', label: 'Thursday' },
        { key: 'friday', label: 'Friday' },
        { key: 'saturday', label: 'Saturday' },
        { key: 'sunday', label: 'Sunday' },
    ];

    return (
        <Card sx={{ height: '100%' }}>
            <CardContent>
                {experience ? (
                    <Stack spacing={2} divider={<Divider />}>
                        <Box
                            sx={{
                                py: 1,
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                cursor: 'pointer',
                                pr: 2,
                                transition: 'padding-right 0.3s ease-in-out',
                                '&:hover': {
                                    pr: 1,
                                },
                            }}
                            onClick={() =>
                                navigate(
                                    `/viewExperiences/${loggedInUser?.company}/${experience.type}/${experience.id}`,
                                )
                            }
                        >
                            <Box sx={{ display: 'flex', gap: 2 }}>
                                <img
                                    src={experience.photos[0]?.src}
                                    width={50}
                                    style={{
                                        borderRadius: 3,
                                        objectFit: 'cover',
                                    }}
                                />
                                <div>
                                    <Typography variant='subHeading'>
                                        {experience.name}
                                    </Typography>
                                    <Typography variant='body3'>
                                        {experience.streetAddress},{' '}
                                        {experience.suburb}, {experience.state}
                                    </Typography>
                                </div>
                            </Box>
                            <NavigateNext />
                        </Box>
                        <div>
                            <Typography sx={{ fontWeight: 'bold' }}>
                                Currently available on:
                            </Typography>
                            <Typography>
                                {days
                                    .filter(
                                        (day) =>
                                            experience[
                                                day.key as keyof Experience
                                            ],
                                    )
                                    .map((day) => day.label)
                                    .join(', ')}
                            </Typography>
                        </div>
                    </Stack>
                ) : (
                    <Stack spacing={2} divider={<Divider />}>
                        <Box
                            sx={{
                                display: 'flex',
                                gap: 2,
                                alignItems: 'center',
                            }}
                        >
                            <div>
                                <Skeleton
                                    variant='rounded'
                                    width={50}
                                    height={50}
                                />
                            </div>
                            <div>
                                <Skeleton variant='text' width={200} />
                                <Skeleton variant='text' width={500} />
                            </div>
                        </Box>
                        <div>
                            <Skeleton variant='text' width={200} />
                            <Skeleton variant='text' width={600} />
                        </div>
                    </Stack>
                )}
            </CardContent>
        </Card>
    );
};

export default ExperiencePreview;
